import { render, staticRenderFns } from "./AddOfferGroupAction.vue?vue&type=template&id=6554dc38&"
import script from "./AddOfferGroupAction.vue?vue&type=script&lang=js&"
export * from "./AddOfferGroupAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports